// import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
height: 85px;
padding: 0.2rem calc((100vw - 1000px) / 2);
z-index: 12;
top: 0;
margin: 0;
background-color: #333;
position: sticky;
display: flex;
justify-content: space-between;
`;

export const NavLink = styled(Link)`
color: #03DAC5;
display: flex;
align-items: center;
text-decoration: none;
padding: 0 1rem;
height: 100%;
cursor: pointer;
&.active {
	color: #4d4dff;
}
`;

export const NavMenu = styled.div`
justify-content: center;
display: flex;
align-items: center;
@media screen and (max-width: 768px) {
	display: none;
}
`;

export const NavImg = styled.img`
display: block;
width: 32px;
`;

export const NavIcon = styled.nav`
align-items: center;
justify-content: center;
margin-left: 10%;
`;